import { useTranslation } from "react-i18next"
import { TFunction } from "i18next"

export default () => {
	const { t } = useTranslation("surveys", { keyPrefix: "form.dataTableHeaders" })

	return columns(t)
}

const columns = (t: TFunction) => [
	{
		key: "id",
		title: "ID",
		dataIndex: "id",
		width: "5%"
	},
	{
		title: t("title"),
		dataIndex: "title",
		key: "title",
		width: "15%",
		ellipsis: true
	},
	{
		title: t("description"),
		dataIndex: "description",
		key: "description",
		width: "25%",
		ellipsis: true
	},
	{
		title: t("microsite"),
		dataIndex: "microsite",
		key: "microsite",
		width: "20%",
		ellipsis: true
	},
	{
		title: t("marketplace"),
		dataIndex: "marketplace",
		key: "marketplace",
		width: "15%",
		ellipsis: true
	},
	{
		key: "status",
		title: t("status"),
		dataIndex: "status",
		filter: true,
		width: "10%"
	},
	{
		title: "",
		dataIndex: "editButton",
		key: "editButton",
		width: "5%"
	},
	{
		title: "",
		key: "duplicateButton",
		dataIndex: "duplicateButton",
		width: "5%"
	}
]
